import React, { useState } from 'react';

import { LayoutOverlay } from 'src/modules/layout';
import { useLocale } from 'src/modules/locale';
import { AssetEntity, AssetsSlider } from 'src/modules/assets';

import { FormattedMessage } from 'react-intl';
import { AssetRow } from 'src/modules/products/components/downloads/AssetRow/AssetRow';
import styles from './ProfessionalsDownloadsDocumentsListing.module.scss';
import classnames from 'classnames';

type AssetGroups = { [s: string]: AssetEntity[] };

export interface ProfessionalsDownloadsDocumentsListingProps {
  assetGroups: AssetGroups;
  displayGroupKey?: boolean;
}

export const ProfessionalsDownloadsDocumentsListing: React.FunctionComponent<ProfessionalsDownloadsDocumentsListingProps> = (
  props
) => {
  const { assetGroups: assetGroupsRaw, displayGroupKey = true } = props;
  const { getLocalizedObject } = useLocale();

  const assetGroups = getLocalizedObject<AssetGroups>(assetGroupsRaw);

  const [activePreviewAsset, setActivePreviewAsset] = useState<AssetEntity>(null);
  const [activeGroupKey, setActiveGroupKey] = useState<string>(null);

  const handleOpenPreview = (asset: AssetEntity, groupKey: string) => {
    setActivePreviewAsset(asset);
    setActiveGroupKey(groupKey);
  };
  const handleClosePreview = () => {
    setActivePreviewAsset(null);
  };

  return (
    <>
      <LayoutOverlay display={!!activePreviewAsset} onClose={handleClosePreview}>
        {!!activePreviewAsset && (
          <AssetsSlider
            activeAsset={activePreviewAsset}
            assets={assetGroups[activeGroupKey].filter((a) => a.type === activePreviewAsset.type)}
          />
        )}
      </LayoutOverlay>

      {Object.keys(assetGroups)
        .filter((key) => assetGroups[key].length)
        .map((key) => (
          <div key={key} className={classnames(styles.assetGroup, `asset-group-${key}`)}>
            {displayGroupKey && (
              <h4 className={styles.assetGroupTitle}>
                <FormattedMessage
                  id={`page/professionals/downloads/documents/listing/type/${key}`}
                />
              </h4>
            )}

            {assetGroups[key].map((asset) => (
              <AssetRow
                key={asset.id}
                asset={asset}
                showMetadata={false}
                onPreviewClick={() => handleOpenPreview(asset, key)}
                enablePreview={true}
              />
            ))}
          </div>
        ))}
    </>
  );
};

export default ProfessionalsDownloadsDocumentsListing;
